import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import activitySeniorF40Webp from '@/assets/landing-activity-female/activity-senior-f-40.webp'
import activitySeniorF50Webp from '@/assets/landing-activity-female/activity-senior-f-50.webp'
import activitySeniorF60Webp from '@/assets/landing-activity-female/activity-senior-f-60.webp'
import activitySeniorF70Webp from '@/assets/landing-activity-female/activity-senior-f-70.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'MENOPAUSE</br> WEIGHT LOSS PLAN',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'BASED ON YOUR <strong>AGE & BMI</strong>',
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40–49',
					img: activitySeniorF40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50-59',
					img: activitySeniorF50Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: 'Age: 60-69',
					img: activitySeniorF60Webp,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: 'Age: 70-80',
					img: activitySeniorF70Webp,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
